import { Injectable } from '@angular/core';
import { StatusResponseModel } from '../../../models/apis/status-response.model';
import { BaseMapper } from '../../base.mapper';
import { StatusResponseHttp } from '../../../http-models/status-response.http';

@Injectable({
    providedIn: 'root',
})
export class DeleteNotificationMapper implements
    BaseMapper<StatusResponseModel,StatusResponseHttp>
{
    convertFrom(http: StatusResponseHttp): StatusResponseModel {
        return {
            isError: http.isError,
            errors: http.errors
        } as StatusResponseModel;
    }

}
